// src/subscreens/Home/ReviewsSection.js
import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import '../../../assets/css/home/ReviewsSection.css';

const ReviewsSection = () => {
  const reviews = [
    {
      name: "Sarah Ahmed",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop",
      review: "CircleHub made group studies easy and interactive. The AI summaries are a game-changer for quick revision!"
    },
    {
      name: "Fatima Khan",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop",
      review: "AI summaries saved time and improved learning. I can now study smarter, not harder!"
    },
    {
      name: "Aisha Malik",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop",
      review: "Quizzes helped in self-assessment. The competition feature keeps me motivated every day."
    },
    {
      name: "Zara Ali",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop",
      review: "Performance tracking kept motivation high. I love seeing my progress visualized clearly!"
    }
  ];

  return (
    <section className="rs-reviews-section">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="rs-section-title">STUDENT REVIEWS</h2>
          </div>
        </div>

        <Carousel
          interval={2500}
          pause="hover"
          indicators={false}
          controls={true}   // ✅ arrows ON
          prevIcon={
            <span className="carousel-control-prev-icon rs-carousel-control-prev-icon" />
          }
          nextIcon={
            <span className="carousel-control-next-icon rs-carousel-control-next-icon" />
          }
          prevLabel=""
          nextLabel=""
          className="rs-carousel"
        >
          {reviews.map((review, index) => (
            <Carousel.Item key={index}>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="rs-review-card">
                    <div className="rs-review-image-wrapper">
                      <img
                        src={review.image}
                        alt={review.name}
                        className="rs-review-image"
                      />
                    </div>

                    <h5 className="rs-review-name">{review.name}</h5>

                    <p className="rs-review-text">
                      “{review.review}”
                    </p>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default ReviewsSection;
